import React, { Component, Fragment } from 'react'
import { Hero } from '../../components/Layout'
import { FilterType, FilterSearch, FilterTags, ButtonDownload, AssignTags } from '../../components/Parts'
import { TableContent } from './components'
import { Button, Tooltip, Icon } from 'antd'
import { types } from '../../store'
import className from 'classnames'

export default class extends Component {
  componentDidMount () {
    const { getStorage, getTags } = this.props

    getStorage()
    getTags()
  }

  componentWillUnmount () {
    const { clearFilters } = this.props

    if (clearFilters) {
      clearFilters()
    }
  }

  render () {
    const {
      storage,
      storage: { table: { rows } },
      setTable,
      setModal,
      setFilterTable,
      download: { files } } = this.props

    return (
      <Fragment>
        <div className={className('download', { 'download_active': files.length > 0 })}>
          <div className='download__inner'>
            <div className='download__head'>
              <div className='download__heading'>{files.filter(file => file.percent >= 100).length === files.length ? 'Downloaded' : 'Downloading'} {files.length} {files.length > 1 ? 'files' : 'file'}{files.filter(file => file.percent >= 100).length !== files.length && '...'} </div>
              {files.filter(file => file.percent >= 100).length === files.length &&
                <div className='download__close' onClick={this.props.clearDownloadList}>
                  <Icon type='close' />
                </div>
              }
            </div>
            <div className='download__list'>
              { files.map((file, i) => <div key={i}>
                <div className='download__item'>
                  <div className='download-item'>
                    <div className='download-item__progress'>
                      <svg className='progress' viewBox='0 0 120 120'>
                        <path className={className('progress__check', { '__success': file.percent >= 100 })} d='M31.9758466,64.055403 C29.5888332,62.0227821 29.3279661,58.4678895 31.3933861,56.1167399 C33.4587971,53.7655902 37.0697,53.5086425 39.4567135,55.5430306 L52.5156195,66.6969296 L79.2515859,40.6371141 C81.4885232,38.4461079 85.1119212,38.4549137 87.3363484,40.6599921 C89.5625606,42.8650786 89.5536356,46.4322784 87.3149081,48.6250577 L56.8053315,78.362898 L56.8035448,78.3611381 C54.7041886,80.4236779 51.3112673,80.569741 49.0332296,78.6268752 L31.975743,64.0553559 L31.9758466,64.055403 Z' transform='translate(59.500000, 59.500000) rotate(90.000000) translate(-59.500000, -59.500000) ' />
                        <circle className={className('progress__meter', { '__success': file.percent >= 100 })} cx='60' cy='60' r='54' strokeWidth='12' />
                        <circle className={className('progress__value', { '__success': file.percent >= 100 })} cx='60' cy='60' r='54' strokeWidth='12' strokeDasharray='339.292' strokeDashoffset={339.292 * ((100 - file.percent) / 100)} />
                      </svg>
                    </div>
                    <div className='download-item__name'>{file.name}</div>
                  </div>
                </div>
              </div>) }
            </div>
          </div>
        </div>
        <div className='app__content'>
          <div className='content__hero'>
            <Hero heading='Content' />
          </div>
          <div className='content__page'>
            <div className='container'>
              <div className='page'>
                <div className='page-content page__content'>
                  <div className='page-content-head page-content__head'>
                    <div className='page-content-head__controls'>
                      <div className='page-content-head__control'>
                        <Button type='indigo' onClick={() => {
                          setModal(types.MODAL_STORAGE_UPLOAD, true)
                          setTable([], [])
                        }}>Upload content</Button>
                      </div>
                    </div>
                    <div className='page-content-head__controls page-content-head__controls_last' style={{ flex: 1 }}>
                      <div className='page-content-head__control page-content-head__control_last' style={{ flex: 1 }}>
                        <FilterSearch />
                      </div>
                    </div>
                  </div>

                  <div className='page-content-head page-content__head'>
                    <div className='page-content-head__control'>
                      <FilterType />
                    </div>
                    <div className='page-content-head__control'>
                      <FilterTags />
                    </div>
                    { rows.length > 0 &&
                    <div className='page-content-head__control'>
                      <AssignTags />
                    </div>
                    }
                    <div className='page-content-head__control'>
                      <Button type='dashed' icon='edit' onClick={() => setModal(types.MODAL_TAGS, { status: true })}>Manage tags</Button>
                    </div>

                    { rows.length > 0 &&
                    <div className='page-content-head__controls page-content-head__controls_last'>

                      { rows.length === 1 &&
                        <Fragment>
                          <div className='page-content-head__control'>
                            <Tooltip title='Edit'>
                              <Button type='dashed' icon='edit' onClick={() => setModal(types.MODAL_STORAGE_EDIT, { status: true, asset: rows[0] })} />
                            </Tooltip>
                          </div>
                          <div className='page-content-head__control'>
                            <Tooltip title='Update'>
                              <Button type='dashed' icon='reload' onClick={() => setModal(types.MODAL_STORAGE_UPDATE, true)} />
                            </Tooltip>
                          </div>
                        </Fragment>
                      }

                      { rows.length >= 1 &&
                        <Fragment>
                          <div className='page-content-head__control'>
                            <ButtonDownload />
                          </div>
                          <div className='page-content-head__control page-content-head__control_last'>
                            <Tooltip title='Delete'>
                              <Button type='dashed' icon='delete' onClick={() => setModal(types.MODAL_STORAGE_DELETE, true)} />
                            </Tooltip>
                          </div>
                        </Fragment>
                      }

                    </div>
                    }
                  </div>

                  <div className='page-content__table'>
                    <TableContent
                      storage={storage}
                      setTable={setTable}
                      setFilterTable={setFilterTable}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Content/Content.jsx